import React, { useState,useEffect } from "react";
import StatsLg from "../../../components/AdminComponents/StatsLg";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export default function Main() {
  /*    <div class="h-52 redborder w-[25%] grid grid-cols-2 grid-rows-2 ">
  <div class="bg-gray-300 redborder "></div>
  <div class="bg-gray-300 redborder"></div>
  <div class="bg-gray-300 redborder"></div>
  <div class="bg-gray-300 redborder"></div>
</div> */

  function getTimeOfDay() {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return "Morning";
    } else if (currentHour >= 12 && currentHour < 18) {
      return "Afternoon";
    } else {
      return "Evening";
    }
  }

  const timeofDay = getTimeOfDay();
  const location = useLocation();

  const [loading ,setloading]= useState(true)

  
  return (
    <div className="min-w-screen min-h-[91vh]  bg-[#f4f8fd] font-[Archivo]">
      <div className=" p-3 lg:pl-[17em] lg:pr-[2em] w-full pt-[1em] ">
    
        <>
        <div className=" mb-6">

          <p className="text-[#494949]">Hello Admin,</p>
          <p className=" text-3xl font-bold">Good {timeofDay}</p>
        </div>
        <StatsLg />
        </>
      </div>
    </div>
  );
}
